<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <!-- <vuexy-logo /> -->

          <h2 class="brand-text text-primary ml-1">Client Portal</h2>
        </b-link>

        <b-card-title class="mb-1"> Welcome to Client Portal! 👋 </b-card-title>
        <b-card-text class="mb-2">
          Please write your Optimum ERP Link and start the adventure
        </b-card-text>

        <!-- form -->
        <validation-observer ref="loginForm" #default="{ invalid }">
          <b-form class="auth-login-form mt-2" @submit.prevent>
            <!-- subdomain -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="subdomain"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="subdomain"
                    v-model="subdomain"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="subdomain"
                    placeholder="subdomain"
                  />

                  <b-input-group-append is-text>
                    .optierp.net
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <div class="divider my-1"></div>
            <!-- submit button -->
            <b-button
              variant="primary"
              type="button"
              @click.prevent="continueLogin"
              block
              :disabled="invalid"
            >
              Continue
            </b-button>
          </b-form>
        </validation-observer>

        <!-- <b-card-text class="text-center mt-2">
          <span>New on our platform? </span>
          <b-link :to="{ name: 'auth-register-v1' }">
            <span>Create an account</span>
          </b-link>
        </b-card-text> -->

        <!-- <div class="divider my-2">
          <div class="divider-text">or</div>
        </div> -->
      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import { required } from "@validations";
import axios from "axios";
export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },

  data() {
    return {
      subdomain: "",

      required,
    };
  },
  methods: {
    continueLogin() {
      this.$refs.loginForm.validate().then((success) => {
        if (success) {
          const baseEnd = "https://" + this.subdomain + ".optierp.net/api/v1/";
          const axiosIns = axios.create({
            baseURL: baseEnd,
            withCredentials: false,
            headers: {
              Accept: "application/json",
            },
          });
          axiosIns
            .get("crm/company-profile")
            .then((response) => {
              localStorage.setItem("subdomain", JSON.stringify(this.subdomain));
              localStorage.setItem(
                "company",
                JSON.stringify(response.data.company)
              );
              window.location.href = "/login-info";
            })
            .catch((error) => {
              this.$refs.loginForm.setErrors({
                subdomain: ["This SubDomain IS Not Valid"],
              });
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
